import { Voice } from '../types/Voice';

import { TwitchStoreState } from './types/TwitchStoreState';

export const getters = {
	selectedVoice(this: TwitchStoreState): Voice | undefined {
		return this.voices?.find((voice) => voice.id === this.selectedVoiceId);
	},

	isLoading(this: TwitchStoreState): boolean {
		return this.voices === undefined;
	},

	hasError(this: TwitchStoreState): boolean {
		return !!this.error;
	},

	isLive(this: TwitchStoreState): boolean {
		return this.isStreaming && this.isEnabled;
	},
};
